document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        if ( mediaVideo = getElements(document.querySelectorAll('.videoElement.local')) ) {


            mediaVideo.forEach(function(element) {
                var video = element.querySelector("video");
                var src = element.querySelector("source");
                var button = element.querySelector("button");

                var playButton = element.querySelector(".play");
                var pauseButton = element.querySelector(".pause");
                var progressBar = element.querySelector("#progress-bar");
                var progressFill = element.querySelector("#progress-fill");
                var currentTimeSpan = element.querySelector("#current-time");
                var remainingTimeSpan = element.querySelector("#remaining-time");
                var fullscreenButton = element.querySelector("#fullscreen");
                var muteButton = element.querySelector("#mute");

                var desktopSrc = src.getAttribute("src");


                button.addEventListener('click', function (event) {
                    video.play();
                    element.classList.add('playing');
                });

                // Start des Videos
                playButton.addEventListener('click', function () {
                    video.play();
                    element.classList.add('playing'); // Setzt Klasse, um Play-Button zu verstecken
                });

                // Pause des Videos
                pauseButton.addEventListener('click', function () {
                    video.pause();
                    element.classList.remove('playing'); // Zeigt Play-Button wieder an
                });

                // Aktualisieren des Fortschrittsbalkens
                video.addEventListener('timeupdate', function () {
                    const currentTime = video.currentTime;
                    const duration = video.duration;
                    const percent = (currentTime / duration) * 100;
                    progressFill.style.width = percent + "%";

                    // Zeitaktualisierungen
                    currentTimeSpan.textContent = formatTime(currentTime);
                    remainingTimeSpan.textContent = "-" + formatTime(duration - currentTime);
                });

                // Fortschrittsbalken-Klick
                progressBar.addEventListener("click", function(e) {
                    const rect = progressBar.getBoundingClientRect();
                    const clickPosition = e.clientX - rect.left;
                    const percent = clickPosition / rect.width;
                    video.currentTime = percent * video.duration;
                });

                fullscreenButton.addEventListener("click", function () {
                    if (video.requestFullscreen) {
                        video.requestFullscreen();
                    } else if (video.mozRequestFullScreen) { // Firefox
                        video.mozRequestFullScreen();
                    } else if (video.webkitRequestFullscreen) { // Chrome, Safari und Opera
                        video.webkitRequestFullscreen();
                    } else if (video.msRequestFullscreen) { // IE/Edge
                        video.msRequestFullscreen();
                    }
                });

                // Event, wenn das Video in den Fullscreen wechselt
                video.addEventListener("fullscreenchange", function() {
                    if (document.fullscreenElement) {
                        element.classList.add("fullscreen-active");
                    } else {
                        element.classList.remove("fullscreen-active");
                    }
                });

                // Video am Ende zurücksetzen
                video.addEventListener('ended', function() {
                    video.currentTime = 0;  // Zeigt Poster erneut
                    element.classList.remove('playing');  // Zeigt Play-Button wieder an
                });



                addMediaQueryWatcher("(max-width: 1344px)", (matches) => {
                    if (matches) {
                        var medium = window.matchMedia("(max-width: 1344px)");

                        if (medium.matches && src.dataset.hasOwnProperty('medium')) {
                            src.setAttribute("src", src.getAttribute('data-medium'));
                            video.load();
                        } else  {

                            if( src.getAttribute("src") != desktopSrc ) {
                                src.setAttribute("src", desktopSrc);
                                video.load();
                            }
                        }
                    }
                });

                addMediaQueryWatcher("(max-width: 720px)", (matches) => {
                    if (matches) {
                        var small = window.matchMedia("(max-width: 720px)");

                        if (small.matches && src.dataset.hasOwnProperty('small')) {
                            src.setAttribute("src", src.getAttribute('data-small'));
                            video.load();
                        } else  {

                            if( src.getAttribute("src") != desktopSrc ) {
                                src.setAttribute("src", desktopSrc);
                                video.load();
                            }
                        }
                    }
                });

                video.onended = function() {
                    video.load(); // show poster again
                    video.removeAttribute("controls")
                    element.classList.remove('playing');
                };




            });

            function formatTime(seconds) {
                const mins = Math.floor(seconds / 60);
                const secs = Math.floor(seconds % 60);
                return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
            }

        }
    });
});
